import styled from 'styled-components';
import { Button, Select } from 'antd';

export const StyledSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledSectionHeader = styled.div`
  font-weight: 600;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledNamesRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledRemoveButton = styled(Button)`
  align-self: center;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;

export const StyledFieldLabel = styled.div`
  font-weight: 300;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledFacilityColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.space_1};
`;

export const StyledAddressSummary = styled.div`
  /* Override LocationSummary's internal hardcoded styles */
  .ant-form-item {
    margin-bottom: 0 !important;
  }

  .ant-form-item,
  p {
    font-size: ${({ theme }) => theme.font.size.xsmall} !important;
    font-weight: 400;
    margin-bottom: 0 !important;
  }
`;
